import React from "react";

export default function Scope(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Definitions & Scope of the Policy
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Definitions (as applicable for this Policy)
          </h2>
          <ul className="space-y-4 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Child: </b>A ‘Child’ is a person who has not completed the
                eighteenth year of age. This is in conformity with the Article 1
                of UN Convention on the Rights of the Child 1989, Section 2(k)
                of the Juvenile Justice (Care and Protection of Children) Act,
                2000 and its subsequent amendments in 2006 and 2015, as well as
                Section 2(1) d of Protection of Children from Sexual Offences
                Act, 2012
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Child Abuse: </b>In line with WHO definition, child abuse is
                defined as "all forms of physical and/or emotional
                ill-treatment, sexual abuse and sexual exploitation, neglect or
                negligent treatment, commercial or other exploitation of a child
                and any action resulting in actual or potential harm to the
                child's health, survival, development or dignity in the context
                of a relationship of responsibility, trust or power.”
                <br />
                <p className="mt-2">
                  Any damage or trauma to a child for which there is no
                  “reasonable explanation” would also be considered as child
                  abuse. Child abuse encompasses non-accidental physical injury,
                  emotional abuse, sexual abuse, exploitation, neglect, bullying
                  etc.
                </p>
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Child Safeguarding: </b>Child Safeguarding is a pro-active
                approach that includes all activities aimed to prevent (i) abuse
                and maltreatment to the child (ii) harm to a child’s physical
                and/or mental health
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Child Protection: </b>Child Protection refers to actions
                undertaken to protect a child in situations where the child is
                at risk of significant harm or is experiencing significant harm.
                <br />
                <p className="mt-2 text-gray-500 italic border border-gray-300 p-1">
                  Note: Safeguarding is preventing harm/abuse while Protection
                  is responding to harm/abuse. However, in many places these two
                  terms are often considered synonymous and used interchangeably{" "}
                </p>
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                <b>Poor Practice: </b>Poor practice occurs when staff fails to
                provide good care and support to children. It refers to
                situations where the behavior or actions of any staff are
                falling below the SS/KVS’s required safety standards and code of
                conduct. Poor practice is also synonymous with behavior with
                contravenes the SS/KVS’s Child Safeguarding & Protection Policy,
                Practices and Procedures. Such behavior could be intentional or
                accidental. The behavior may not be immediately dangerous or
                intentionally harmful to a child, but it is likely to set a poor
                example. Poor practice is an action or activity which, if
                allowed to continue (or repeated), can cause harm to a child and
                can become abuse.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Scope of the Policy
          </h2>
          <span className="text-gray-700 block mb-1">
            The scope of this policy encompasses all persons who are engaged by
            SS/KVS for any work/activities or are associated with
            work/activities of SS/KVS in any capacity, including:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Staff who are on rolls (full time, part time, adhoc basis)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Trainees, interns, volunteers, Fellows
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Consultants, Persons on contract (either directly or through an
                agent, including a contractor, with or without the knowledge of
                the principal employer)
              </span>
            </li>
          </ul>
          <span className="text-gray-700 block mb-4">
            All above are hereinafter collectively mentioned as ‘SS Staff’ for
            the sake of brevity irrespective of whether they may be working on a
            voluntary basis or otherwise as well as whether their terms of
            employment and/ or association with SS are express or implied.
          </span>
          <span className="text-gray-700 block mb-1">
            In addition, the provisions of the policy would also apply to :
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Board and society members of Krida Vikas Sanstha
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Suppliers, vendors, visitors, invitees, etc. of SS/KVS
              </span>
            </li>
          </ul>
          <span className="text-gray-700 block mb-1">
            They are hereinafter collectively mentioned as ‘Associates’
          </span>
        </div>
      </div>
    </div>
  );
}
